<template>
    <el-tabs v-bind="$attrs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabsTitle" :key="index">
            <slot :name="item.name"></slot>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    props: {
        tabsTitle: { type: Array, default: null },
    },
    data() {
        return {
            activeName: 'first'
        }
    },
    methods: {
        handleClick(tab, event) {
            // currentTab.value = tab.props.label;
            // emits("curretnTab", tab.props);
            // emits("update:modelValue");
        }
    },
    mounted() {
        
    },
    onUnmounted(){
    }
}
</script>

<style lang="less" scoped>
.el-tabs {
    --layout-bg-color: #fff;
    --el-text-color-primary: #333;
    flex-direction: column;
    flex: 1;
    display: flex;

    ::v-deep .el-tabs__content {
        // padding-top: 12px;
        // font-weight: 600;
        flex: 1;
    }

    ::v-deep .el-tabs__header {
        box-shadow: none;
        border-bottom: 1px solid rgb(239, 239, 245);

        .el-tabs__nav-wrap {
            &:after {
                content: none;
            }
        }
    }

    ::v-deep .el-tabs__item {
        text-align: center;
        color: #333;

        &.is-active {
            color: #1677ff;
        }

        &:hover {
            color: #1677ff;
        }

        .el-tabs__active-bar {
            color: #1677ff;
        }
    }

    ::v-deep .el-tab-pane {
        color: #333;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}
</style>